var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialMediaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.621094,
    y: 0.460938,
    width: 36,
    height: 36,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0858 27.4609V19.2503H22.9805L23.4139 16.0504H20.0858V14.0075C20.0858 13.081 20.3559 12.4497 21.7514 12.4497L23.5311 12.4489V9.58701C23.2233 9.54808 22.1668 9.46094 20.9378 9.46094C18.3717 9.46094 16.615 10.9521 16.615 13.6907V16.0504H13.7129V19.2503H16.615V27.4609H20.0858V27.4609Z",
    fill: "#5D2EDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMediaIcon);
export default __webpack_public_path__ + "static/media/Social Media Icon.1b461470ee1994ac11aa74cac34f2b0c.svg";
export { ForwardRef as ReactComponent };